import React, { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { RouteAccessGuard } from './RouteAccessGuard';

import { Login } from '../pages/Login';
import { MainMenu } from '../pages/MainMenu';
import { PoliticaPrivacidad } from '../pages/PoliticaPrivacidad';
import { Stats } from '../pages/Stats';
import { Admin } from '../global/administrador/Admin';
import { PrepararExportacionFichajes } from '../global/administrador/exportacion/PrepararExportacionFichajes';
import { Usuarios } from '../global/administrador/usuarios/Usuarios';
import { Document } from '../global/documentacion/Document';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import { Header } from '../global/Header';
import { Footer } from '../global/Footer';
import { Grid } from '@mui/material';

import { BtnSubir } from '../utils/BtnSubir';
import { RecursosHumanos } from '../global/rrhh/RecursosHumanos';
import { Cuadrillas } from '../global/cuadrillas/Cuadrillas';
import { Campanas } from '../global/cuadrillas/Campanas';
import { PanelOperativos } from '../global/cuadrillas/PanelOperativos';
import { Personas } from '../global/documentacion/Personas';
import { Carpetas } from '../global/documentacion/Carpetas';
import { Documentos } from '../global/documentacion/Documentos';
import { DetallePersona } from '../global/documentacion/DetallePersona';
import { Convenios } from '../global/rrhh/Convenios';
import { SincronizacionesEoer } from '../global/administrador/sincronizacion/SincronizacionesEoer';
import { PermisosDocumentacion } from '../global/administrador/permisos/PermisosDocumentacion';
import { PermisosOperativa } from '../global/administrador/permisos/PermisosOperativa';
import { Delegaciones } from '../global/administrador/delegaciones/Delegaciones';

// colores de los componentes del MUI
const theme = createTheme({
	palette: {
		primary: {
			main: '#384314',
		},
		secondary: {
			main: '#c8d11d',
		},
		blanco: {
			main: '#F5F7F8'
		}
	},
});

const Router = () => {
	//global
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [openDrawer, setOpenDrawer] = useState(
		localStorage.getItem('openDrawer') === 'true'
	);

	useEffect(() => {
		localStorage.setItem('openDrawer', openDrawer);
	}, [openDrawer]);

	const withRouteAccess = (routePath, element) => (
		<RouteAccessGuard routePath={routePath}>{element}</RouteAccessGuard>
	);

	return (
		<BrowserRouter> {/* Añade BrowserRouter aquí */}
			<ThemeProvider theme={theme}>
				<div className='back-main fade-in'>
					<Grid container size={{ xs: 12 }} direction={'column'}>
						<Grid container size={{ xs: 12 }} direction={'row'}>
							<Header setOpenDrawer={setOpenDrawer} openDrawer={openDrawer} />
						</Grid>
						<Grid container size={{ xs: 12 }} direction={'row'}>
							<Grid container size={{ xs: 12 }} sx={{ pb: 10 }}>
								<Grid container size={{ xs: 12 }} direction={'row'}>
									<Grid container size={{ xs: 12 }} direction={'column'}>
										<Routes>
											<Route element={<PrivateRoute />}>
												<Route path="/" element={<MainMenu />}></Route>
												<Route path="/stats" element={<Stats />}></Route>

												{/* //recursos humanos */}
												<Route
													path="/rrhh"
													element={withRouteAccess("/rrhh", <RecursosHumanos />)}
												></Route>

												{/* //jornadas */}
												{/* <Route path="/jornadas" element={<Jornadas />}></Route> */}

												{/* //tareas */}
												{/* //calendario */}
												{/* <Route path="/calendario" element={<Calendario />}></Route> */}

												{/* //admin */}
												<Route
													path="/admin"
													element={withRouteAccess("/admin", <Admin />)}
												></Route>

												<Route
													path="/admin/sincronizaciones-eoer"
													element={withRouteAccess(
														"/admin/sincronizaciones-eoer",
														<SincronizacionesEoer />
													)}
												></Route>
												<Route
													path="/admin/documentacion/permisos"
													element={withRouteAccess(
														"/admin/documentacion/permisos",
														<PermisosDocumentacion />
													)}
												></Route>
												<Route
													path="/admin/permisos-operativa"
													element={withRouteAccess(
														"/admin/permisos-operativa",
														<PermisosOperativa />
													)}
												></Route>
												{/* <Route
													path="/admin/delegaciones"
													element={withRouteAccess(
														"/admin/delegaciones",
														<Delegaciones />
													)}
												></Route> */}

												{/* //Cuadrillas */}
												<Route
													path="/cuadrillas"
													element={withRouteAccess("/cuadrillas", <Cuadrillas />)}
												></Route>
												<Route
													path="/cuadrillas/operativos"
													element={withRouteAccess("/cuadrillas/operativos", <PanelOperativos />)}
												></Route>
												<Route
													path="/campanas"
													element={withRouteAccess("/campanas", <Campanas />)}
												></Route>

												{/* //usuarios */}
												<Route
													path="/usuarios"
													element={withRouteAccess("/usuarios", <Usuarios />)}
												></Route>


												{/* //documentos */}
												<Route
													path="/documentos"
													element={withRouteAccess("/documentos", <Document />)}
												></Route>

												{/* //personas */}
												<Route
													path="/personas"
													element={withRouteAccess("/personas", <Personas />)}
												></Route>
												<Route
													path="/personas/:id"
													element={withRouteAccess("/personas/:id", <DetallePersona />)}
												></Route>

												{/* //carpetas */}
												<Route
													path="/carpetas"
													element={withRouteAccess("/carpetas", <Carpetas />)}
												></Route>

												{/* //documentos */}
												<Route
													path="/documentacion"
													element={withRouteAccess("/documentacion", <Documentos />)}
												></Route>
												<Route
													path="/exportar"
													element={withRouteAccess("/exportar", <PrepararExportacionFichajes />)}
												></Route>
												{/* <Route
													path="/convenios"
													element={withRouteAccess("/convenios", <Convenios />)}
												></Route> */}
												<Route
													path="/operativos"
													element={withRouteAccess("/operativos", <PanelOperativos />)}
												></Route>

												{/* //departamentos */}
												{/* <Route path="/rolesydepartamentos" element={<RolesYDepartamentos />}></Route> */}

												{/* //notificaciones */}
												{/* <Route path="/notificaciones" element={<Notificaciones />}></Route> */}

												{/* //fichajes */}
												{/* <Route path="/fichajes" element={<Fichajes />}></Route>

												<Route path="/fichajesusuario/:id" element={<FichajesUsuario />}></Route> */}

											</Route>
											{/* //global */}
											<Route path="/login?" element={<Login username={username} setUsername={setUsername} password={password} setPassword={setPassword} />}></Route>
											<Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />}></Route>
											<Route path="*" element={<Navigate to="/" replace />} />
										</Routes>
									</Grid>

								</Grid>
							</Grid>
							<BtnSubir></BtnSubir>
							<Footer></Footer>
						</Grid>
					</Grid>
				</div>
			</ThemeProvider>
		</BrowserRouter>
	)
}

export default Router
